import React from 'react';
import QueryClauseTableRow from './QueryClauseTableRow';
import QueryFiltersTableRows from '../../filters/components/QueryFiltersTableRows';
import ClauseProfileRows from '../../profile/components/ClauseProfileRows';

const QueryClauseTableRows = ({
  code,
  category,
  canEdit,
  isEditing,
  clause,
  queryUUID,
  firstClause,
  validationErrors,
}) => (
  <>
    <QueryClauseTableRow
      category={category}
      code={code}
      clause={clause}
      queryUUID={queryUUID}
      canEdit={canEdit}
      firstClause={firstClause}
      isEditing={isEditing}
    />
    {clause.profile.showCounts && (
      <ClauseProfileRows
        clauseUUID={clause.uuid}
        code={code}
        category={category}
        canEdit={canEdit}
        isEditing={isEditing}
        queryUUID={queryUUID}
      />
    )}
    <QueryFiltersTableRows
      clause={clause}
      code={code}
      category={category}
      canEdit={canEdit}
      isEditing={isEditing}
      queryUUID={queryUUID}
      validationErrors={validationErrors}
    />
  </>
);

export default QueryClauseTableRows;
